module.exports = __webpack_public_path__ + "ca0eb28b4f8db291863d1af2f028267a.jpg";